import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CallProvider } from "@/context/CallContext";
import { CallEvents } from "@/components/CallEvents";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Matchmaking from "@/pages/Matchmaking";
import VideoChat from "@/pages/VideoChat";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import Safety from "@/pages/Safety";
import { AuthCallback } from "@/components/AuthCallback";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Connecting…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "moderator") return <Navigate to="/dashboard" replace />;
  if (user.role === "user" && user.email_verified === false) return <Navigate to="/verify-email" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/safety" element={<Safety />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/match" element={<Protected><Matchmaking /></Protected>} />
      <Route path="/chat" element={<Protected><VideoChat /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => { document.title = "Orbit Hello — Say hello to the world"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <CallProvider>
          <AppRoutes />
          <CallEvents />
          <Toaster theme="dark" position="top-center" richColors />
        </CallProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
